/* TILOA, 14/10/2026 : tiroir panier en mode « offre 2 pour 1 » (snippets/cart-drawer.liquid,
   snippets/tiloa-offre-panier-pied.liquid). Chargé sur toutes les pages par le tiroir ; ne fait rien
   tant que le tiroir ne contient pas le portefeuille Essentiel.

   1. Délai de 5 minutes (bandeau [data-tp-delai] en tête de la liste) :
      - départ au premier affichage du portefeuille dans le tiroir, heure conservée dans le navigateur
        (localStorage, repli en mémoire) : fermer, rouvrir ou recharger la page ne le remet pas à 05:00 ;
      - il ne repart de zéro que si le portefeuille quitte le panier ;
      - à 00:00, le bandeau vert devient un avertissement (classe is-expire), annoncé une fois aux lecteurs
        d'écran. Rien d'autre ne change : panier, remise, couleurs et paiement restent intacts.
      Le tiroir est réécrit par le thème à chaque modification : un observateur réapplique l'état avant
      l'affichage suivant (pas de « 05:00 » fugitif).
   2. Encadré « offre plus complète » : ajout d'un portefeuille de la couleur choisie (une unité, au clic
      seulement), puis rendu du tiroir par le thème (renderContents), comme un ajout depuis une fiche.
   3. Bouton de paiement du mode offre : un appui arrivé moins de 0,7 s après l'ouverture du tiroir est
      ignoré (2e appui d'un double appui sur « Ajouter les 2 portefeuilles », qui tombait sur ce bouton). */
(function () {
  'use strict';
  if (window.__tiloaOffrePanier) return;
  window.__tiloaOffrePanier = true;

  var CLE = 'tiloa_offre_delai_v1';
  var DUREE = 5 * 60 * 1000;
  var GARDE_OUVERTURE = 700;
  var MSG_FIN = 'Le délai est écoulé : la disponibilité peut avoir évolué.';
  var MSG_ERREUR = 'L\'ajout n\'a pas abouti. Réessayez dans un instant.';

  var memoire = null;
  var dernierEtat = null; // 'actif' | 'expire' : l'annonce n'est faite qu'au passage de l'un à l'autre
  var ouvertLe = 0;

  function lire() {
    try {
      var v = parseInt(window.localStorage.getItem(CLE), 10);
      if (v > 0) return v;
    } catch (e) {}
    return memoire;
  }
  function ecrire(t) {
    memoire = t;
    try { window.localStorage.setItem(CLE, String(t)); } catch (e) {}
  }
  function effacer() {
    memoire = null;
    try { window.localStorage.removeItem(CLE); } catch (e) {}
  }
  function deux(n) { return (n < 10 ? '0' : '') + n; }
  function tiroir() { return document.querySelector('cart-drawer'); }

  /* ---------- 1. Délai ---------- */
  function majDelai() {
    var d = tiroir();
    if (!d || !d.querySelector('#CartDrawer')) return;
    var bandeau = d.querySelector('[data-tp-delai]');
    var offre = d.querySelector('.tp-op-ligne');
    if (!offre) {
      // Plus de portefeuille au panier : le prochain ajout ouvre un nouveau délai.
      if (bandeau) bandeau.hidden = true;
      effacer();
      dernierEtat = null;
      return;
    }
    if (!bandeau) return;
    var maintenant = Date.now();
    var debut = lire();
    // Heure absente ou incohérente (horloge modifiée, valeur future) : nouveau départ.
    if (!debut || debut > maintenant + 60000) {
      debut = maintenant;
      ecrire(debut);
    }
    var reste = Math.max(0, DUREE - (maintenant - debut));
    var s = Math.ceil(reste / 1000);
    var temps = bandeau.querySelector('[data-tp-delai-temps]');
    if (temps) {
      var txt = deux(Math.floor(s / 60)) + ':' + deux(s % 60);
      if (temps.textContent !== txt) temps.textContent = txt;
    }
    var etat = s <= 0 ? 'expire' : 'actif';
    if (bandeau.classList.contains('is-expire') !== (etat === 'expire')) bandeau.classList.toggle('is-expire', etat === 'expire');
    if (bandeau.hidden) bandeau.hidden = false;
    if (etat === 'expire' && dernierEtat === 'actif') {
      var annonce = bandeau.querySelector('[data-tp-delai-annonce]');
      if (annonce) annonce.textContent = MSG_FIN;
    }
    dernierEtat = etat;
  }

  /* ---------- 2. Ajout du portefeuille offert ---------- */
  function routeAjout() {
    var r = window.routes || {};
    return (r.cart_add_url || '/cart/add') + '.js';
  }

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.matches || !r.matches('input[name="tp-op-couleur"]')) return;
    var bloc = r.closest('[data-tp-incomplet]');
    var nom = bloc && bloc.querySelector('[data-tp-couleur-nom]');
    if (nom) nom.textContent = r.getAttribute('data-nom') || '';
  });

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-tp-ajout-offert]') : null;
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    var bloc = b.closest('[data-tp-incomplet]');
    if (!bloc) return;
    var choix = bloc.querySelector('input[name="tp-op-couleur"]:checked:not(:disabled)') ||
      bloc.querySelector('input[name="tp-op-couleur"]:not(:disabled)');
    var statut = bloc.querySelector('[data-tp-ajout-statut]');
    if (!choix) return;
    var d = tiroir();
    var sections = d && typeof d.getSectionsToRender === 'function'
      ? d.getSectionsToRender().map(function (x) { return x.id; })
      : [];
    var texte = b.textContent;
    b.setAttribute('aria-busy', 'true');
    b.disabled = true;
    b.textContent = 'Ajout en cours…';
    if (statut) statut.textContent = '';

    fetch(routeAjout(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(choix.value), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) { return { ok: r.ok && j && !j.status, j: j }; });
      })
      .then(function (x) {
        if (!x.ok) {
          var err = new Error('ajout');
          err.description = x.j && (x.j.description || x.j.message);
          throw err;
        }
        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tiloa-offre-panier', cartData: x.j });
        }
        if (d && typeof d.renderContents === 'function' && x.j.sections) {
          d.renderContents(x.j);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        b.disabled = false;
        b.removeAttribute('aria-busy');
        b.textContent = texte;
        if (statut) statut.textContent = (err && err.description) || MSG_ERREUR;
      });
  });

  /* ---------- 3. Bouton de paiement juste après l'ouverture ---------- */
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('#CartDrawer-Checkout') : null;
    if (!b || !b.closest('.tp-op-pied')) return;
    if (Date.now() - ouvertLe < GARDE_OUVERTURE) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* ---------- Suivi du tiroir ---------- */
  function brancher() {
    var d = tiroir();
    if (!d) return;
    var actif = d.classList.contains('active');
    if (actif) ouvertLe = Date.now();
    new MutationObserver(function () {
      var maintenant = d.classList.contains('active');
      if (maintenant && !actif) ouvertLe = Date.now();
      actif = maintenant;
      majDelai();
    }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    majDelai();
    window.setInterval(function () {
      if (d.classList.contains('active') || d.querySelector('[data-tp-delai]:not([hidden])')) majDelai();
    }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();
})();
